// extracted by mini-css-extract-plugin
export var optionGrid = "_br-7";
export var optionList = "_br-6";
export var questionsBlock = "_br-9";
export var spacer = "_br-5";
export var stepCenteredContent = "_br-3";
export var stepInner = "_br-0";
export var stepInnerFullWidth = "_br-1";
export var stepInnerLockScroll = "_br-2";
export var stepTransitionFrame = "_br-4";
export var welcomeBlock = "_br-8";